export default function resolveUncollectedPreviousPresentation(machine = {}, type = "") {
  const isNonAccumulativeSlot = type === "Tragamoneda" && machine?.IsAccumulative === false;
  if (isNonAccumulativeSlot) {
    const hasFormula =
      machine?.FormulaId != null ||
      machine?.FormulaType != null ||
      machine?.HistoricalFormula?.Id != null ||
      machine?.Formula?.Id != null;
    return {
      label: "Anterior:",
      useMoney: !hasFormula,
      inValue: hasFormula ? machine?.PrevNetCreditsIn : machine?.PrevNetMoneyIn,
      outValue: hasFormula ? machine?.PrevNetCreditsOut : machine?.PrevNetMoneyOut,
    };
  }

  const hasCreditsPrev = machine?.PrevCreditsIn != null || machine?.PrevCreditsOut != null;
  const hasMoneyPrev = machine?.PrevMoneyIn != null || machine?.PrevMoneyOut != null;
  const useMoney =
    type === "Rockola" || (type === "Tragamoneda" && hasMoneyPrev && !hasCreditsPrev);
  return {
    label: useMoney ? "Dinero Anterior:" : "Creditos anteriores:",
    useMoney,
    inValue: useMoney ? machine?.PrevMoneyIn : machine?.PrevCreditsIn,
    outValue: useMoney ? machine?.PrevMoneyOut : machine?.PrevCreditsOut,
  };
}
